<script setup>
defineProps({
  isBlock: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <div
    :class="{
      [$style.wrapper]: true,
      [$style.block]: isBlock,
    }"
  >
    <div
      :class="{
        [$style.spinner]: true,
        [$style[color]]: !!color,
      }"
    />
  </div>
</template>

<style module>
/*
 * Geometry constants: border 2px, size 20px, duration .6s.
 * The leading/trailing dots are positioned on the spinner's circle. With
 * center = 7px, radius = 9px and root = sqrt(2)/2 ≈ 0.70710678118:
 *   x (and the alternate "before" dot) = round(center + radius * root) = 13px
 *   y                                  = round(center - radius * root) = 1px
 * so :after sits at top 1px / left 13px and :before at top 13px / left 13px.
 */

/* Wrapper */
.wrapper {
  display: inline-block;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  &.block {
    display: flex;
    justify-content: center;
    padding: 2rem;
  }
}

/* Spinner */
.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-color: var(--p-form-field-icon-color);
  border-right-color: transparent !important;
  border-radius: 50%;
  position: relative;
  animation: rotate 0.6s linear infinite;
  &:after {
    content: '';
    width: 2px;
    height: 2px;
    border-radius: 50%;
    position: absolute;
    top: 1px;
    left: 13px;
    background: var(--p-form-field-icon-color);
  }
  &:before {
    content: '';
    width: 2px;
    height: 2px;
    border-radius: 50%;
    position: absolute;
    top: 13px;
    left: 13px;
  }
  &.white {
    border-color: var(--color-white);
    &:after {
      background: var(--color-white);
    }
  }
  &.primary {
    border-color: var(--color-primary);
    &:after {
      background: var(--color-primary);
    }
  }
  &.success {
    border-color: var(--color-status-success);
    &:after {
      background: var(--color-status-success);
    }
  }
  &.warning {
    border-color: var(--color-status-warning);
    &:after {
      background: var(--color-status-warning);
    }
  }
  &.danger {
    border-color: var(--color-status-danger);
    &:after {
      background: var(--color-status-danger);
    }
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
